import { createSelector } from 'reselect'
import settingsHelper from '../../../helpers/utils/settings'
import settingsEnums from '../../../helpers/enums/settings'
import { IStore } from '../../reducers/index'

const settingsSelector = (state: IStore) => state.game.settings

export default createSelector(settingsSelector, (settings) =>
	settingsHelper.getSettingValue(settings, settingsEnums.SETTING_TYPE_GAME_MODE)
)
